module.exports = __webpack_public_path__ + "img/login-main-chat.136258e8.svg";